import { useEffect, useState, useCallback } from "react";
import { getAllLoanFund, addNewLoanFund, updateLoanFund, deleteLoanFund, reactivateLoanFund } from "../Service";


export default function useLoanFund(status = null) {
  const [page, setPage] = useState(0);
  const [user, setUser] = useState(null);
  const [userList, setUserList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
  const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
  const [shouldOpenReactivateConfirmationDialog, setShouldOpenReactivateConfirmationDialog] = useState(false);


  const handleChangePage = (_, newPage) => setPage(newPage);

  const updatePageData = useCallback(() => {
    console.log(status);
    getAllLoanFund(status).then(response => {
      setUserList(response.data.loanFunds || []);
    }).catch(error => {
      console.error('Failed to fetch loan Fund data', error);
    });
  }, [status]);


  const handleDialogClose = () => {
    setShouldOpenEditorDialog(false);
    setShouldOpenConfirmationDialog(false);
    setShouldOpenReactivateConfirmationDialog(false);
    updatePageData();
  };

  const handleDeleteUser = (user) => {
    setUser(user);
    setShouldOpenConfirmationDialog(true);
  };

  const handleSaveLoanFund = async (loanFundDetails, isNew, setFieldError) => {
    const apiPayload = {
      code: loanFundDetails.code,
      description: loanFundDetails.description
    };

    if (isNew) {
      const response = await addNewLoanFund(apiPayload);
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
        return null;
      } else {
        setFieldError('code', response.data.errorMessage);
        return response.data.errorMessage;
      }
    }
  };

  const handleEditLoanFund = async (loanFundDetails, setFieldError) => {
    const apiPayload = {
      id: loanFundDetails.id,
      code: loanFundDetails.code,
      description: loanFundDetails.description
    };

    const response = await updateLoanFund(apiPayload);
    if (response.data.success) {
      handleDialogClose();
      setTimeout(updatePageData, 500);
      return null;
    } else {
      setFieldError('code', response.data.errorMessage);
      return response.data.errorMessage;
    }
  };


  const handleReactivateConfirmationResponse = async () => {
    if (user) {
      const response = await reactivateLoanFund({ id: user.id });
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
      }
    }
  };

  const handleConfirmationResponse = async () => {
    if (user) {
      const response = await deleteLoanFund({ id: user.id });
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
      }
    }
  };

  const handleEditUser = (user) => {
    setUser(user);
    setShouldOpenEditorDialog(true);
  };

  const handleReactivateFund = (user) => {
    setUser(user);
    setShouldOpenReactivateConfirmationDialog(true);
  };


  useEffect(() => {
    updatePageData();
  }, [updatePageData]);


  return {
    page,
    user,
    setUser,
    userList,
    rowsPerPage,
    setRowsPerPage,
    handleSaveLoanFund,
    handleEditUser,
    handleDeleteUser,
    handleChangePage,
    handleDialogClose,
    shouldOpenEditorDialog,
    setShouldOpenEditorDialog,
    handleConfirmationResponse,
    shouldOpenConfirmationDialog,
    handleEditLoanFund,
    handleReactivateFund,
    updatePageData,
    handleReactivateConfirmationResponse,
    setShouldOpenReactivateConfirmationDialog,
    shouldOpenReactivateConfirmationDialog
  };
}
